import { Divider, Skeleton } from '@gravity-ui/uikit';
import styles from '../styles.module.scss';

export const LoaderAdaptive = () => {
	return (
		<div className={styles.blank_info}>
			<div className={styles.blank_info__block}>
				<Skeleton style={{ maxWidth: '252px', height: '24px' }} />
				<div className={styles.blank_info__block__center}>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<Divider />
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<Divider />
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
				</div>
			</div>
			<div className={styles.blank_info__block}>
				<Skeleton style={{ maxWidth: '252px', height: '24px' }} />
				<div className={styles.blank_info__block__center}>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '44px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '334px', height: '44px' }} />
					</div>
					<div style={{ display: 'flex', gap: '8px' }}>
						<Skeleton style={{ maxWidth: '160px', height: '20px' }} />
						<Skeleton style={{ maxWidth: '504px', height: '20px' }} />
					</div>
				</div>
			</div>
		</div>
	);
};
